import Vue from 'vue';
import api from '@/factories/api';
import EventBus from '@/factories/eventBus';

let initialized = false;

export default {
  namespaced: true,

  state: () => ({
    byContact: {},
    // contacts whose full presence list has been fetched, not just seen in an event
    hydrated: {},
  }),

  mutations: {
    upsertInstance(
      state,
      {
        contact_id,
        agent_id,
        agent_type,
        agent_name,
        presence,
        presence_updated_at,
      }
    ) {
      const item = {
        agent_id,
        agent_type,
        agent_name,
        presence,
        presence_updated_at,
      };
      const list = state.byContact[contact_id];
      if (!list) {
        Vue.set(state.byContact, contact_id, [item]);
        return;
      }
      const idx = list.findIndex((i) => i.agent_id === agent_id);
      if (idx === -1) {
        list.push(item);
      } else {
        list.splice(idx, 1, item);
      }
    },

    hydrateContact(state, { contactId, instances }) {
      Vue.set(state.byContact, contactId, instances || []);
      state.hydrated[contactId] = true;
    },
  },

  getters: {
    runningAgentsForContact: (state) => (contactId) =>
      (state.byContact[contactId] || []).filter(
        (i) => i.presence === 'running'
      ),
  },

  actions: {
    async hydrateContacts({ commit }, contactIds) {
      if (!contactIds || !contactIds.length) return;

      const unique = [...new Set(contactIds.map(String).filter(Boolean))];
      if (!unique.length) return;

      for (let i = 0; i < unique.length; i += 300) {
        const chunk = unique.slice(i, i + 300);
        try {
          const result = await api({ skipErrorModal: true }).post(
            'agent/custom/presence',
            { contact_ids: chunk }
          );
          const responseMap = result || {};
          chunk.forEach((contactId) => {
            commit('hydrateContact', {
              contactId,
              instances: responseMap[contactId] || [],
            });
          });
        } catch {
          // presence is non-critical — silently ignore fetch errors
        }
      }
    },

    init({ commit, dispatch, state }) {
      if (initialized) return;
      initialized = true;

      EventBus.$on('agent.status', (data) => {
        commit('upsertInstance', {
          ...data,
          presence: data.status,
          presence_updated_at: new Date().toISOString(),
        });
      });

      const rehydrateKnown = () => {
        const knownIds = Object.keys(state.byContact);
        if (knownIds.length) dispatch('hydrateContacts', knownIds);
      };

      EventBus.$on('ably.connected', rehydrateKnown);

      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) rehydrateKnown();
      });
    },
  },
};
